import Image from "next/image";
import type { Session } from "next-auth";
import { Spinner } from "../Spinner";
import classes from "./GoogleAuthorizationButton.module.scss";
import { IoChevronDown } from "react-icons/io5";
import { FcGoogle } from "react-icons/fc";
import IFThen from "@/components/common/IFThen";
import { When } from "@/components/common/When";
type Props = {
  user: Session["user"];
  loading: boolean;
  onClick: (e: React.MouseEvent) => void;
};
const GoogleAuthorizationButton = ({
  user,
  loading,
  onClick
}: Props) => {
  return <div onClick={onClick} className={classes.google_auth} data-sentry-component="GoogleAuthorizationButton" data-sentry-source-file="GoogleAuthorizationButton.tsx">
      <div className={classes.google_auth_container}>
        <IFThen condition={loading} Then={<div className={classes.container_loading}>
              <Spinner />
            </div>} Else={<When condition={!!user}>
              <div className={classes.container_detail}>
                <div className={classes.container_detail_pp}>
                  {user?.image && <Image src={user!.image!} alt={user!.name!} width={20} height={20} />}
                </div>
                <div className={classes.container_detail_name}>
                  <b>Continue as {user?.name}</b>
                  <span>
                    {user?.email}
                    <IoChevronDown size={16} />
                  </span>
                </div>
              </div>
              <FcGoogle size={24} />
            </When>} data-sentry-element="IFThen" data-sentry-source-file="GoogleAuthorizationButton.tsx" />
      </div>
    </div>;
};
export default GoogleAuthorizationButton;